import { Record } from 'immutable';
export default Record({
  deckId: null,
  lastUpdatedAt: null,
  lastUpdatedByUserId: null,
  legalConsentEnabled: false
}, 'GDPRRecord');